import { createAsyncThunk, createSlice, nanoid } from "@reduxjs/toolkit";
import yuklemeData from "../../utils/yukOptions/yuklemeData";
import bosaltmaData from "../../utils/yukOptions/bosaltmaData";
import { setResultModalData, showModal } from "../modal/modalSlice";
import {
  aracData,
  paketlemeData,
  paketlemeTypes,
  paymentData,
  yukData,
  routeData,
} from "../../utils/loadInitialData/data";
import locationData from "../../utils/locationData/locationOptions";
import axiosInstance from "../../axios/axiosInstance";
import { toastApiError } from "../../helper/api/toastApiError";
import { getTopPagesNotificationsCounts } from "../notification/notificationSlice";
import agirlikBirimOptions from "../../utils/yukOptions/agirlikBirimOptions";
import yuklemeTuruOptions from "../../utils/yukOptions/yüklemeTuruOptions";
import paketlemeItemDimensions from "../../utils/yukOptions/paketlemeItemDimension";
import zeminTypeOptions from "../../utils/yukOptions/zeminTypeOptions";
import yakitDurumuOptions from "../../utils/yukOptions/yakitDurumuOptions";
import komisyonDurumuOptions from "../../utils/yukOptions/komisyonDurumuOptions";
import fiyatlandirmaTipOptions from "../../utils/yukOptions/fiyatlandirmaTipOptions";
import odemeSekliOptions from "../../utils/yukOptions/odemeSekliOptions";
import addLoadLocationData from "../../utils/locationData/addLoadLocationOptions";
import sevkBicimleriOptions from "../../utils/yukOptions/sevkBicimleriOptions";
import { unwrapApiList } from "../../helper/load/registeredLoadPayload";
const initialState = {
  route: [
    {
      id: nanoid(),
      locationData: {
        il: "",
        ilId: "",
        ilce: "",
        ilceId: "",
        
        lat: "",
        lng: "",
        location: "",
        bolge: "",
        locationId: "",

        googleLat: 38.75,
        googleLng: 33.75,
        googleLocation: "",
        googleSearchText: "",
        isGoogleAddressSelected: false,
        isfirstChanged: false,
      },
      //! yetkili bilgileri
      companyName: "",
      mailAddress: "",
      routePointPersonPhoneNumber: "",
      routePointPersonName: "",
      smsVerificationPhoneNumber:"",
      smsVerification: false,
      adres: "",
      adresTarif: "",
      adresKaydedilsinMi: false,
      adresBaslik: "",
      date: "",
      dateEngec: "",
      saatBaslangic: "08:00",
      saatBitis: "18:00",
      saatAllTime: false,
      locationType: "yukleme",
      //! kendinden önceki tarihle farkı kontrol ediyor (ffk)
      dateInfo: false,
      //! kendinden sonra tarihle farkı kontrol ediyor (ffk)
      dateAfterInfo: false,
      //! bugünün tarihinden önce bir tarih girildi mi (ffk)
      currentDateControl:false,
      order: 1,
      sevkBicimleri: [
        {
          id: 1,
          name: "Forkliftle",
          status: false,
        },
        {
          id: 2,
          name: "Rampadan",
          status: false,
        },
        {
          id: 3,
          name: "Vinçle",
          status: false,
        },
        {
          id: 4,
          name: "Elle",
          status: false,
        },
        {
          id: 5,
          name: "Dökme",
          status: false,
        },
        {
          id: 6,
          name: "Yandan",
          status: false,
        },
        {
          id: 7,
          name: "Babalar Çıksın",
          status: false,
        },
      ],
    },
    {
      id: nanoid(),
      locationData: {
        il: "",
        ilce: "",
        lat: "",
        lng: "",
        googleLat: 38.75,
        googleLng: 33.75,
        googleLocation: "",
        googleSearchText: "",
        isGoogleAddressSelected: false,
        isfirstChanged: false,
        location: "",
        bolge: "",
        ilId: "",
        ilceId: "",
        locationId: ""
      },

      adres: "",
      adresTarif: "",
      adresKaydedilsinMi: false,
      adresBaslik: "",
      date: "",
      dateEngec: "",
      saatBaslangic: "08:00",
      saatBitis: "18:00",
      saatAllTime: false,
      locationType: "bosaltma",
      //! yetkili bilgileri
      companyName: "",
      mailAddress: "",
      routePointPersonPhoneNumber: "",
      routePointPersonName: "",
      smsVerificationPhoneNumber:"",
      smsVerification: false,

      //! kendinden önceki tarihle farkı kontrol ediyor (ffk)
      dateInfo: false,
      //! kendinden sonra tarihle farkı kontrol ediyor (ffk)
      dateAfterInfo: false,
      //! bugünün tarihinden önce bir tarih girildi mi (ffk)
      currentDateControl:false,
      order: 2,
      sevkBicimleri: [
        {
          id: 1,
          name: "Forkliftle",
          status: false,
        },
        {
          id: 2,
          name: "Rampadan",
          status: false,
        },
        {
          id: 3,
          name: "Vinçle",
          status: false,
        },
        {
          id: 4,
          name: "Elle",
          status: false,
        },
        {
          id: 5,
          name: "Dökme",
          status: false,
        },
        {
          id: 6,
          name: "Yandan",
          status: false,
        },
        {
          id: 7,
          name: "Babalar Çıksın",
          status: false,
        },
      ],
    },
  ],

  aracData: {
    aracSayisi: 1,
    aracTypeName: "",
    aracTypeId: "",
    kasaTypeName: "",
    kasaTypeId: "",
    //! modal açılmasını kontrol etmek için (ffk)
    aracSayisiKontrol: false,
    kasaTypeOptions: [],
    zeminType: {
      value: "",
      text: "",
    },
    digerOzellikler: "",
  },

  paymentData: {
    yukverenFiyat: "",
    hedefNakliyefiyat: "",
    fiyatlandirmaType: {
      value: 0,
      text:"TL/Komple"
    },
    fiyatYayinlansin: true,
    odemeSekli: {
      value: "",
      text: "",
    },
    odemeSekliDigerAciklama: "",
    yakitDurumu: {
      value: "",
      text: "",
    },
    yakitOrani: 0,
    komisyonDurumu: {
      value: "",
      text: "",
    },
    komisyonMiktari: 0,
  },

  yukData: {
    //! options
    yuklemeTuru: {
      value: false,
      text: "FTL(Komple Araç)",
    },

    //! text
    yukTuru: "",

    //! bool
    yukADR: false,
    yukAdrDescription: "",

    agirlikBirim: {
      value: "",
      text: "",
    },
    toplamAgirlik: "",
    toplamHacim: "",
    yukDesc: "",
    yukunDegeri: "",
    companyLoadNumber: "",
    customsPlace: "",
    vesselDate: "",
    isFreeZone: false,
    yukunDegeriKontrol: false,
    ustUsteYuklenmesin: false,
  },

  paketlemeData: [
    {
      id: nanoid(),
      activePaketlemeTypeId: 1,
      paketlemeType: "Palet",
      list: [
        {
          id: nanoid(),
          en: 120,
          boy: 80,
          yukseklik: 0,
          agirlik: 0,
          sayisi: 0,
        },
      ],
    },
  ],

  paketlemeTypes: [
    {
      id: 1,
      name: "Palet",
      isOther: false, //! bu diğerlerinin içinde görünüp görünmeyeceğini belirler
    },
    {
      id: 2,
      name: "Kutu",
      isOther: false,
    },
    {
      id: 3,
      name: "Dökme",
      isOther: false,
    },

    {
      id: 4,
      name: "Big Bag",
      isOther: false,
    },
    {
      id: 5,
      name: "Varil Bidon",
      isOther: true,
    },
    {
      id: 6,
      name: "Teneke",
      isOther: true,
    },
    {
      id: 7,
      name: "IBC",
      isOther: true,
    },
    {
      id: 0,
      name: "Diğer",
      isOther: true,
    },
  ],

  selectedProjectAddLoad: null,
  yayinlamaSecenegi: null,
  routeDistance: null,

  //! bu route item veya paketleme item silinmek istenirse permmission almak için
  routePermissionData: null,
  paketlemePermissionData: null,

  //! map modal açıldığında ilgili itemın datası
  routeItem: null,
  routeItemName: null,
  selectedItem: null,
  defaultRouteState: null,

  clearPermisionLoadDataPiece: null,

  //! localStorage da yapılan değişiklikten ayrı tutacağımız state
  memorieRouteData: null,

  //! bu show errors eğer submit esnasında zorunlu alanları doldurmazsa diye
  showErrors: false,

  //! bu da kullanıcı sadece zorunlu alanları görüntülemek isterse diye
  showRequiredPlaces: false,

  //! other tools
  isLoadingAddLoad: false,
  isError: false,
  message: "",

  //! tarihleri karşılaştırmak için tuttuğum stateler
  currentDate: null,

  //! burası haritanın ekleme kımında nasıl görüneceğini belirtecek (geniş mi yoksa dar mı olacak)
  mapScopeType: "normal",

  //! selectedRouteItem (adres için)
  selectedRouteItem: null,

  selectedRouteItemType: null,

  adresSelectMapZoom: 6,

  //! error lerin sayısını göstermek için
  errorDataList: {
    yuklemeDataErrorList: [],
    bosaltmaDataErrorList: [],
    yukDataErrorList: [],
    paymentDataErrorList: [],
    aracDataErrorList: [],
  },

};

const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;

export const addLoad = createAsyncThunk( "addLoad/addLoad", async ({yukData, isKayitliYukAsked}, thunkApi) => {
    try {
      

      const { data } = await axiosInstance.post( `/Load/AddLoadNew`, yukData);
      if (data.statusCode === 200) {
        if (isKayitliYukAsked) {
          thunkApi.dispatch(showModal("addLoadYukKaydi"));
        }
        else {
          thunkApi.dispatch(showModal("addLoadSuccess"));
        }
        thunkApi.dispatch(getTopPagesNotificationsCounts({companyList: []}));
        const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
        storage.removeItem("routeData");
        // thunkApi.dispatch(resetAddLoadState());
      } else {
        const message = toastApiError(
          data,
          "Bir hata oluştu, lütfen daha sonra tekrar deneyin"
        );
        thunkApi.dispatch(
          setResultModalData({
            msg: message,
            btnText1: "Tamam",
          })
        );
        
      }
      return data;
    } catch (error) {
      const message = toastApiError(
        error,
        "Bir hata oluştu, lütfen daha sonra tekrar deneyin"
      );
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(
        setResultModalData({
          msg: message,
          routePath: "/yukler-listesi",
          resultType: "error",
          btnText1: "Listeyi Görüntüle",
        })
      );
      return thunkApi.rejectWithValue({ message });
    }
  }
);


export const addQuickLoad = createAsyncThunk( "addLoad/addQuickLoad", async (yukData, thunkApi) => {
  try {

    const { data } = await axiosInstance.post( `/Load/CreateQuickLoad`, yukData);
    if(data.statusCode === 200){

    }
    if (data.statusCode === 200) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Hızlı Yük Ekleme İşlemi Başarı İle Gerçekleştirildi.", resultType: "success", btnText1: "Harika",}));
      const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
      storage.removeItem("routeData");
      thunkApi.dispatch(resetAddLoadState());
    } else {
      thunkApi.dispatch(
        setResultModalData({
          msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin",
          btnText1: "Tamam",
        })
      );
      
    }
    return data;
  } catch (error) {
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(
      setResultModalData({
        msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin",
        routePath: "/yukler-listesi",
        resultType: "error",
        btnText1: "Listeyi Görüntüle",
      })
    );
    return thunkApi.rejectWithValue(error);
  }
}
);

const addLoadSlice = createSlice({
  name: "addLoad",
  initialState,
  reducers: {
    addRouteItem: (state, action) => {
      const { type } = action.payload;

      if (type === "yukleme") {
        const lastItemIndex = state.route.findLastIndex((item) => item.locationType === "yukleme");

        const newItem = { ...yuklemeData, id: nanoid() };
        const updatedList = [...state.route];

        updatedList.splice(lastItemIndex + 1, 0, newItem);

        state.route = updatedList;
      }

      if (type === "bosaltma") {
        const lastItemIndex = state.route.findLastIndex((item) => item.locationType === "bosaltma");

        const newItem = { ...bosaltmaData, id: nanoid()};
        const updatedList = [...state.route];

        updatedList.splice(lastItemIndex + 1, 0, newItem);
        state.route = updatedList;
      }

      //!
      const returnData = state.route.map((item) => {
        const { id, ...others } = item;
        return others;
      });
      storage.setItem("routeData", JSON.stringify(returnData));
    },

    updateRouteItem: (state, action) => {
      
      state.route = state.route.map((item) => {
        if (item.id === action.payload.id) {
          return { ...item, ...action.payload };
        } else {
          return item;
        }
      });
      const returnData = state.route.map((item) => {
        const { id, ...others } = item;
        return others;
      });
      storage.setItem("routeData", JSON.stringify(returnData));
    },

    //! kayıtlı yükler için route
    setKayitliYukRouteItem: (state, action) => {
      
      state.route = unwrapApiList(action.payload).map((item) => {
        const sevkBicimIds = unwrapApiList(item?.loadMethods).map(idItem => idItem.methodId)
        const savedLocation = addLoadLocationData?.find(innerItem => innerItem.location === item.location)
        return {
          routePointPersonPhoneNumber: item.routePointPersonPhoneNumber,
          companyName: item.companyName,
          mailAddress: item.mailAddress,
          routePointPersonName: item.routePointPersonName,
          smsVerification: item.smsVerification,
          smsVerificationPhoneNumber: item.smsVerificationPhoneNumber,

          adres: item.address,
          // date: moment(item.loadDate).format('YYYY-MM-DD'),
          // dateEngec: moment(item.lateLoadDate).format('YYYY-MM-DD'),
          // saatBitis: item.lateLoadTime,
          // saatBaslangic: item.loadTime,
          date: "",
          dateEngec: "",
          saatBitis: item?.lateLoadTime,
          saatBaslangic: item?.loadTime,
          locationData: {
            il: savedLocation?.city ?? item?.city ?? "",
            ilce: savedLocation?.town ?? item?.town ?? "",
            lat: item?.lat ?? savedLocation?.lat ?? "",
            lng: item?.lng ?? savedLocation?.lng ?? "",
            location: item?.location ?? savedLocation?.location ?? "",
            bolge: savedLocation?.region ?? "",
            ilId: savedLocation?.cityId ?? "",
            ilceId: savedLocation?.townId ?? "",
            googleLat: item?.googleLat ?? item?.lat ?? "",
            googleLng: item?.googleLng ?? item?.lng ?? "",
            isGoogleAddressSelected: Boolean(item?.isGoogleAddressSelected),
            googleLocation: item?.googleAddress ?? "",
            googleSearchText: item?.googleAddress ?? "",
            isfirstChanged: false,
          },
          id: item.id,
          adresTarif: item?.forDirections,
          adresKaydedilsinMi: item?.isAddressSaved,
          order: item?.order,
          adresBaslik: item?.savedAddressName ?? "",
          saatAllTime: false,
          locationType: item?.loadOrUnload === 0 ? "yukleme" : "bosaltma",
          //! kendinden önceki tarihle farkı kontrol ediyor (ffk)
          dateInfo: false,
          //! kendinden sonra tarihle farkı kontrol ediyor (ffk)
          dateAfterInfo: false,
          //! bugünün tarihinden önce bir tarih girildi mi (ffk)
          currentDateControl:false,

          sevkBicimleri: sevkBicimleriOptions.map(innerItem => {
            return {
              ...innerItem,
              status: sevkBicimIds.includes(innerItem.id)
            }
          })
        }
      })
    },
    //! kayıtlı yükler yük data
    setKayitliYuklerYukData: (state, action) => {
      state.yukData = {
        yuklemeTuru: yuklemeTuruOptions.find(item => item?.value === action.payload.isParsiyel),
        yukTuru: action.payload.loadType,
        yukADR: action.payload.isDangerous,
        yukAdrDescription: action.payload.dangerousDescription,
        agirlikBirim: agirlikBirimOptions.find(item => item.text === action.payload.loadUnit) ,
        toplamAgirlik: action.payload.loadQuantity,
        toplamHacim: action.payload.loadBulk,
        yukDesc: action.payload.loadDescription,
        yukunDegeri: action.payload.loadValue,
        companyLoadNumber: action.payload.companyLoadNumber ?? "",
        customsPlace: action.payload.customsPlace ?? "",
        vesselDate: action.payload.vesselDate?.slice?.(0, 10) ?? "",
        isFreeZone: Boolean(action.payload.isFreeZone),
        yukunDegeriKontrol: false,
        ustUsteYuklenmesin: Boolean(action.payload.isStacked),
      }
    },
    //! kayıtlı yükler paketleme
    setKayitliYuklerPaketlemeData: (state, action) => {
      
      state.paketlemeData = unwrapApiList(action.payload?.packingingTypes).map((item) => {
        const findPaketlemeType = paketlemeItemDimensions?.find(findItem => findItem.id === item.packagingUnitId)
        return {
          id: nanoid(),
          activePaketlemeTypeId: findPaketlemeType?.id,
          paketlemeType: findPaketlemeType?.name,
          list: unwrapApiList(item?.olculers)
        }
      })
      
      
    },

    //! kayıtlı yükler araç
    setKayitliYuklerAracData: (state, action) => {
      const {aracTypes = [], data = {}} = action.payload
      const findArac = unwrapApiList(aracTypes).find((item)=> {
        return item?.id === data?.truckTypeId
      })
      state.aracData = {
        aracSayisi: data.truckQuantity,
        aracTypeName: findArac?.name,
        aracTypeId: data?.truckTypeId,
        kasaTypeName: data?.trailerType,
        kasaTypeId: data?.trailerTypeId,
        aracSayisiKontrol:false,
        digerOzellikler: data?.truckDescription,
        kasaTypeOptions: unwrapApiList(findArac?.trailerTypesModel),
        zeminType: zeminTypeOptions?.find(item => item.value === data?.groundTypeId) ?? {value: 0, text: "Farketmez"}
      }
    },

    setKayitliYuklerPaymentData: (state, action) => {
      state.paymentData = {
        yukverenFiyat: action.payload.loadOwnerFreight ?? "",
        hedefNakliyefiyat: action.payload.freight ?? "",
        fiyatlandirmaType: fiyatlandirmaTipOptions?.find(item => item.value === action.payload.paymentUnit),
        fiyatYayinlansin: action.payload.freightVisibility,
        odemeSekli: odemeSekliOptions?.find(item => item.text === action.payload.paymentType) ,
        odemeSekliDigerAciklama: action.payload.otherPaymentDescription,
        yakitDurumu: yakitDurumuOptions?.find(item => item.value === action.payload.fuelPaymentId),
        yakitOrani: action.payload.fuelPayment,
        komisyonDurumu: komisyonDurumuOptions.find(item => item.value === action.payload.commissionPaymentId),
        komisyonMiktari: action.payload.commissionPayment,
      }
    },

    deleteRouteItem: (state, action) => {
      const updatedList = state.route.filter((item) => {
        return item.id !== action.payload.id;
      });

      state.route = updatedList.map((item, i) => {
        return { ...item, order: i + 1 };
      });
      const returnData = state.route.map((item) => {
        const { id, ...others } = item;
        return others;
      });
      storage.setItem("routeData", JSON.stringify(returnData));
    },

    updateAracData: (state, action) => {
      state.aracData = { ...state.aracData, ...action.payload };
      storage.setItem("aracData", JSON.stringify(state.aracData));
    },

    updatePaymentData: (state, action) => {
      state.paymentData = { ...state.paymentData, ...action.payload };
      storage.setItem("paymentData", JSON.stringify(state.paymentData));
    },

    updateYukData: (state, action) => {
      state.yukData = { ...state.yukData, ...action.payload };
      storage.setItem("yukData", JSON.stringify(state.yukData));
    },

    //! bu paketleme item ı eklenmesi
    addPaketlemeItem: (state) => {
      const data = {
        id: nanoid(),
        activePaketlemeTypeId: 1,
        paketlemeType: "Palet",
        ustUsteYuklenmesin: false,
        ustUsteMiktar: 0,
        list: [
          {
            id: nanoid(),
            en: 120,
            boy: 120,
            yukseklik: 0,
            agirlik: 0,
            sayisi: 0,
          },
        ],
      };
      state.paketlemeData = [...state.paketlemeData, data];

      const returnedData = state.paketlemeData.map((item) => {
        const { id, ...others } = item;
        return others;
      });
      const othersData = returnedData.map((item) => {
        const list = item.list.map((item) => {
          const { id, ...others } = item;
          return others;
        });
        return list;
      });

      storage.setItem("paketlemeData", JSON.stringify(othersData));
    },

    //! bu paketleme itemlarının güncellemesi
    updatePaketlemeItem: (state, action) => {
      state.paketlemeData = state.paketlemeData.map((item) => {
        if (item.id === action.payload.id) {
          return { ...item, ...action.payload };
        } else {
          return item;
        }
      });

      const returnedData = state.paketlemeData.map((item) => {
        const { id, ...others } = item;
        return others;
      });

      const othersData = returnedData.map((item) => {
        const list = item.list.map((item) => {
          const { id, ...others } = item;
          return others;
        });
        return list;
      });

      storage.setItem("paketlemeData", JSON.stringify(othersData));
    },

    //! delete paketleme Item
    deletePaketlemeItem: (state, action) => {
      state.paketlemeData = state.paketlemeData.filter((item) => {
        return item.id !== action.payload.id;
      });
      const returnedData = state.paketlemeData.map((item) => {
        const { id, ...others } = item;
        return others;
      });
      const othersData = returnedData.map((item) => {
        const list = item.list.map((item) => {
          const { id, ...others } = item;
          return others;
        });
        return list;
      });

      storage.setItem("paketlemeData", JSON.stringify(othersData));
    },

    //!  u aynı paketleme item ından farklı ölçülerde eklemek için
    addPaketlemeDimensionItem: (state, action) => {
      const { id, dimensions } = action.payload;
      state.paketlemeData = state.paketlemeData.map((item) => {
        if (item.id === id) {
          const list = [
            ...item.list,
            { ...dimensions, id: item.list.length + 1 },
          ];
          return { ...item, list };
        } else {
          return item;
        }
      });
      const returnedData = state.paketlemeData.map((item) => {
        const { id, ...others } = item;
        return others;
      });
      const othersData = returnedData.map((item) => {
        const list = item.list.map((item) => {
          const { id, ...others } = item;
          return others;
        });
        return list;
      });

      storage.setItem("paketlemeData", JSON.stringify(othersData));
    },

    updatePaketlemeDimensionItem: (state, action) => {
      const { id, dimensionId, updatedData } = action.payload;
      state.paketlemeData = state.paketlemeData.map((item) => {
        
        if (item.id === id) {
          
          const updatedList = item.list.map((item) => {
            
            if (item.id === dimensionId) {
              return { ...item, ...updatedData };
            }
            return item;
          });
          return { ...item, list: updatedList };
        }
        return item;
      });
      const returnedData = state.paketlemeData.map((item) => {
        const { id, ...others } = item;
        return others;
      });
      const othersData = returnedData.map((item) => {
        const list = item.list.map((item) => {
          const { id, ...others } = item;
          return others;
        });
        return list;
      });

      storage.setItem("paketlemeData", JSON.stringify(othersData));
    },

    //! rota planla aşaması değişiklikleri rotadaki değişiklikleri olduğu gibi kaydetmek için
    setRoute: (state, action) => {
      state.route = action.payload;
      storage.setItem("routeData", JSON.stringify(state.route));
    },

    setRouteDistance: (state, action) => {
      state.routeDistance = action.payload;
      storage.setItem("routeDistanceData",JSON.stringify(state.routeDistance));
    },

    //! bu rota item isilinrken permission almak için
    //! storage a kaydedilen değişiklikleri güncelleyeceğimiz yerler (ffk)

    setPaketlemeData: (state, action) => {
      state.paketlemeData = action.payload;
      storage.setItem("paketlemeData",JSON.stringify(state.routeDistance));
    },

    setPaymentData: (state, action) => {
      state.paymentData = action.payload;
      storage.setItem("paymentData", JSON.stringify(state.routeDistance));
    },

    setYukData: (state, action) => {
      state.yukData = action.payload;
      storage.setItem("yukData", JSON.stringify(state.routeDistance));
    },

    setAracData: (state, action) => {
      state.aracData = action.payload;
      storage.setItem("aracData", JSON.stringify(state.routeDistance));
    },

    //! localStorage a kaydedilen değişiklikleri güncelleyeceğimiz yerler bitiş (ffk)

    setRoutePermissionData: (state, action) => {
      state.routePermissionData = action.payload;
    },

    //! bu paketleme item ı açıldığında permission almak için
    setPaketlemePermissonData: (state, action) => {
      state.paketlemePermissionData = action.payload;
    },

    //! map modal açıldığında ilgili itemın datasını alan metod
    setRouteItem: (state, action) => {
      state.routeItem = action.payload;
    },

    setItemName: (state, action) => {
      state.setItemName = action.payload;
    },

    setErrors: (state, action) => {
      state.showErrors = action.payload;
    },

    setRequiredPlacesErrors: (state, action) => {
      state.showRequiredPlaces = action.payload;
    },

    setSelectedItem: (state, action) => {
      state.selectedItem = action.payload;
    },

    //! use memo kullanarak route dizisini haritadan seçim alanı için tuttuğumuz state
    setDefaultRouteState: (state, action) => {
      state.defaultRouteState = action.payload;
    },

    //! tarihleri güncelle bunu daha sonra güncelleyeceğiz
    setCurrentDate: (state, action) => {
      state.currentDate = action.payload;
    },

    //! route dizisini haritadan seçim alanı için kaydetme ya da iptal olma durumunu ayarladığımız state
    setUpdateRouteMap: (state, action) => {
      state.route = action.payload;
    },

    //! bu yuk eklemede bölgesel yük eklemek için
    getClearPermisionLoadDataPiece: (state, action) => {
      state.clearPermisionLoadDataPiece = action.payload;
    },

    setSelectedProjectAddLoad: (state, action) => {
      state.selectedProjectAddLoad = action.payload
    },

    //! burası bölgesel sıfırlama için
    clearLoadDataPiece: (state, action) => {
      const { typeId } = action.payload;
      if (typeId === 1) {
        state.route = state.route.map((item) => {
          if (item.locationType === "yukleme") {
            return { ...routeData[0], order: item.order };
          } else {
            return item;
          }
        });
      }

      if (typeId === 2) {
        state.route = state.route.map((item) => {
          if (item.locationType === "bosaltma") {
            return { ...routeData[1], order: item.order };
          } else {
            return item;
          }
        });
      }

      if (typeId === 1 || typeId === 2) {
        state.routePermissionData = null;
        state.paketlemePermissionData = null;
        state.routeItem = null;
        state.routeItemName = null;
        state.selectedItem = null;
        state.defaultRouteState = null;
        state.routeDistance = 0;
      }

      if (typeId === 4) {
        state.paketlemeData = paketlemeData;
        state.paketlemeTypes = paketlemeTypes;
        state.yukData = yukData;
      }
      if (typeId === 5) {
        state.aracData = aracData;
      }
      if (typeId === 6) {
        state.paymentData = paymentData;
      }
    },

    //! error sayısını güncellemek için
    updateErrorDataList: (state, action) => {
      state.errorDataList = action.payload;
    },

    //! localStore dan gelen dataya yedek olarak tuttuğumuz dizi
    setMemorieRouteData: (state, action) => {
      state.memorieRouteData = action.payload;
    },

    //! bu kayitli adreslerden seçerse otomatik olarak route inputlarını doldurmak için
    setKayitliAdresRouteItem:(state, action) => {
      const {routeId, data} = action.payload
      const selectedLocation = (data?.locationId !== null && data?.locationId !== undefined
        ? locationData.find(innerItem => String(innerItem.townId) === String(data.locationId))
        : undefined)
        ?? locationData.find(innerItem => innerItem.town === data?.addressTown && innerItem.city === data?.addressCity)
        ?? locationData.find(innerItem => innerItem.town === data?.addressTown)
      
      state.route = state.route.map(item => {
        if(item.id === routeId){
          return {
            ...item,
            locationData: selectedLocation ? {
              il: selectedLocation.city,
              ilce: selectedLocation.town,
              bolge: selectedLocation.region,
              ilId: selectedLocation.cityId,
              iceId: selectedLocation.townId,
              lat: data?.addressLat ?? selectedLocation.lat,
              lng: data?.addressLong ?? selectedLocation.lng,
              location: selectedLocation.location,
            } : {
              ...item.locationData,
              lat: data?.addressLat ?? item.locationData?.lat,
              lng: data?.addressLong ?? item.locationData?.lng,
            },
            adres: data?.address,
            adresTarif: data?.addressInfo || "",
            adresBaslik: data?.addressName ?? ""
          }
        }
        else{
          return item
        }
      })
    },

    //! bu adres için
    setSelectedRouteItem: (state, action) => {
      state.selectedRouteItem = action.payload;
    },

    setSelectedRouteItemType: (state, action) => {
      state.selectedRouteItemType = action.payload;
    },

    setAdresSelectMapZoom: (state,action) => {
      state.adresSelectMapZoom = action.payload;
    },

    //! burası haritanın ekleme kımında nasıl görüneceğini belirtecek (geniş mi yoksa dar mı olacak)
    setMapScopeType: (state, action) => {
      state.mapScopeType = action.payload
    },

    //! initial state haline dönme (ffk)
    resetAddLoadState() {
      return initialState; // Başlangıç durumu ile state sıfırlanır
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addLoad.pending, (state) => {
        state.isLoadingAddLoad = true;
      })

      .addCase(addLoad.fulfilled, (state, action) => {
        state.isLoadingAddLoad = false;
      })

      .addCase(addLoad.rejected, (state, action) => {
        state.isLoadingAddLoad = false;
        state.isError = true;
      });
  },
});

export const {
  addRouteItem,
  updateRouteItem,
  deleteRouteItem,

  updateAracData,
  updatePaymentData,
  updateYukData,

  addPaketlemeItem,
  updatePaketlemeItem,
  deletePaketlemeItem,

  addPaketlemeDimensionItem,
  updatePaketlemeDimensionItem,

  setRouteDistance,
  setRoute,
  setRoutePermissionData,
  setPaketlemePermissonData,

  setRouteItem,
  setItemName,

  setErrors,
  setRequiredPlacesErrors,

  setSelectedItem,
  setDefaultRouteState,
  setUpdateRouteMap,

  getClearPermisionLoadDataPiece,
  clearLoadDataPiece,
  //! localStorage kaydetme
  setMemorieRouteData,

  //! localStorage güncelleme
  setAracData,
  setYukData,
  setPaymentData,
  setPaketlemeData,

  //! tarihleri güncelle bunu daha sonra güncelleyeceğiz
  setCurrentDate,

  //!
  updateErrorDataList,
  setKayitliAdresRouteItem,

  //!
  setMapScopeType,

  setSelectedRouteItem,
  setSelectedRouteItemType,
  
  setAdresSelectMapZoom,
  
  //! tüm state i sıfırlamak için
  //! reset (ffk)
  resetAddLoadState,

  setKayitliYukRouteItem,
  setKayitliYuklerYukData,
  setKayitliYuklerPaketlemeData,
  setKayitliYuklerAracData,
  setKayitliYuklerPaymentData,
  setSelectedProjectAddLoad
} = addLoadSlice.actions;
export default addLoadSlice.reducer;
